export default __webpack_public_path__ + "static/media/all-together-now.33150fdd.webp";